import { MASK, HASH, DENY } from './policyEffectStrings'

export const POLICY_EFFECT_URL_ENUM = {
  MASK,
  HASH,
  DENY,
}
